import { RecordValue, NumberValue, BooleanValue, Value, ArrayValue, StringValue, } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload, requiredNonEmptyString, serializeSchemaValidationError, validatePayloadAndThrow, } from '../../../../utils/validate-payload.js';
import { deselectAllFacetValues } from '../../facet-set/facet-set-actions.js';
import { facetIdDefinition } from '../../generic/facet-actions-validation.js';
import { updateRangeFacetSortCriterion } from '../generic/range-facet-actions.js';
import { numericFacetValueDefinition } from '../generic/range-facet-validate-payload.js';
const numericFacetRequestDefinition = {
    state: requiredNonEmptyString,
    start: new NumberValue({ required: true }),
    end: new NumberValue({ required: true }),
    endInclusive: new BooleanValue({ required: true }),
};
const numericFacetRegistrationOptionsDefinition = {
    facetId: facetIdDefinition,
    field: requiredNonEmptyString,
    tabs: new RecordValue({
        options: {
            required: false,
        },
        values: {
            included: new ArrayValue({ each: new StringValue() }),
            excluded: new ArrayValue({ each: new StringValue() }),
        },
    }),
    activeTab: new StringValue({ required: false }),
    currentValues: new ArrayValue({
        required: false,
        each: new RecordValue({ values: numericFacetRequestDefinition }),
    }),
    generateAutomaticRanges: new BooleanValue({ required: true }),
    filterFacetCount: new BooleanValue({ required: false }),
    injectionDepth: new NumberValue({ required: false, min: 0 }),
    numberOfValues: new NumberValue({ required: false, min: 1 }),
    sortCriteria: new Value({ required: false }),
    rangeAlgorithm: new Value({ required: false }),
};
export function validateManualNumericRanges(options) {
    if (!options.currentValues) {
        return;
    }
    options.currentValues.forEach(({ start, end }) => {
        if (start > end) {
            throw new Error(`The start value is greater than the end value for the numeric range ${start} to ${end}`);
        }
    });
}
export const registerNumericFacet = createAction('numericFacet/register', (payload) => {
    try {
        validatePayload(payload, numericFacetRegistrationOptionsDefinition);
        validateManualNumericRanges(payload);
        return { payload, error: null };
    }
    catch (error) {
        return { payload, error: serializeSchemaValidationError(error) };
    }
});
export const toggleSelectNumericFacetValue = createAction('numericFacet/toggleSelectValue', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    selection: new RecordValue({ values: numericFacetValueDefinition }),
}));
export const toggleExcludeNumericFacetValue = createAction('numericFacet/toggleExcludeValue', (payload) => validatePayload(payload, {
    facetId: facetIdDefinition,
    selection: new RecordValue({ values: numericFacetValueDefinition }),
}));
export const updateNumericFacetValues = createAction('numericFacet/updateFacetValues', (payload) => {
    try {
        validatePayloadAndThrow(payload, {
            facetId: facetIdDefinition,
            values: new ArrayValue({
                each: new RecordValue({ values: numericFacetValueDefinition }),
            }),
        });
        validateManualNumericRanges({ currentValues: payload.values });
        return { payload, error: null };
    }
    catch (error) {
        return { payload, error: serializeSchemaValidationError(error) };
    }
});
export const updateNumericFacetSortCriterion = updateRangeFacetSortCriterion;
export const deselectAllNumericFacetValues = deselectAllFacetValues;
